import React, {
    useState,
    useEffect
} from "react";
import {
    Row
} from "react-bootstrap";
import { FootnotePageDataFormatter, FootnotePageDataDeformatter, getUniqueLists } from "./FootnotesHelperFunctions";
import { FootnoteGrid } from "./FootnotesGridTable";



export const FootnoteTable = (props) => {
    const [data, setData] = useState([])
    const [footNotes, setFootnotes] = useState()
    const [page, setPage] = useState("")
    const [header, setHeader] = useState("")
    const [footnotePages, setFootNotesPages] = useState([])
    useEffect(() => {
        console.log("HEADER: ", props.header)
        setHeader(props.header)
    }, [props.header])
    useEffect(() => {
        console.log("PAGES: ", parseInt(props.page.at(-1)))
        setPage(parseInt(props.page.at(-1)))
    }, [props.page])

    useEffect(() => {
        // console.log("FOOTOTES DATA ORIGIAL FORMAT: ", props.data)
        if (props.data !== undefined) {
            setFootnotes(props.data)
        }
        console.log("FOOTNOTES DATA: ", props.data)
    }, [props.data])

    useEffect(() => {
        if (footNotes !== null && footNotes !== undefined) {
            const groupedFootnotes = [];
            const pg = parseInt(props.page.at(-1));
            for (let [_, data] of Object.entries(footNotes)) {
                for (let [key, record] of Object.entries(data)) {
                    if (Array.isArray(record.pages) && record.pages.includes(pg)) {
                        for (let ftnt of record.data) {
                            ftnt.push(key.split(". ")[0].replace(/\D/g, ''));
                            groupedFootnotes.push(ftnt);
                        }
                    }
                }
            }
            const groupedUniqueFootnotes = getUniqueLists(groupedFootnotes);
            const temp = FootnotePageDataFormatter(groupedUniqueFootnotes);
            setData(temp);
        }
    }, [footNotes]);


    const updateFootnote = (data) => {
        console.log("UPDATED FOOTNOTES DATA FOR THE SECTION: ", data)
        console.log("ORIGINAL FOOTNOTES: ", footNotes)
        const footnotesCopy = Object.assign({}, footNotes)
        for (let ftnt of data) {
            for (let [_, fd] of Object.entries(footnotesCopy)) {
                for (let [key, record] of Object.entries(fd)) {
                    if (key.split("."[0].replace(/\D/g, '') === ftnt["header"])) {
                        for (let ftnote of record.data) {
                            if (ftnote[0] === ftnt["field"]) {
                                ftnote[1] = ftnt["amount"]
                                ftnote[2] = ftnt["selected"]
                                props.updatefootnotedata(key, record)
                            }
                        }
                    }
                }
            }
        }
        console.log("UPDATED FOOTNOTES: ", footnotesCopy)
        setFootnotes(footnotesCopy)
       }

    return (
        <>
            <Row className="no-gutter" style={{ height: "100%", width: "100%" }}>
                <div style={{ minWidth: "100%", padding: "20px 20px 0px 20px", height: `100%`, overflowY: "auto" }}>
                    <FootnoteGrid
                        rowData={data}
                        header={header}
                        updateddata={(data) => updateFootnote(data)}
                        rowSelection={'multiple'}
                        rowMultiSelectWithClick={true}
                        sortable={true}
                        filter={true}
                        resizable={true}
                        footnotepages={footnotePages}
                        gotopage={(page) => props.setactivepage(page)}
                    />
                </div>
                <div className="intent-buttons" style={{ marginTop: 10 }}>
                    {/* <Button className="intent-save" onClick={() => SaveChanges()}> Update</Button> */}
                    {/* <a style={{ cursor: "pointer", color: "var(--theme1_tertiary)" }} onClick={() => goToPage(grid_props.footnotepages)}>Go to the footnotes page <Icon.BoxArrowInUpRight style={{ color: "var(theme1_primary)", fontSize: 12 }} /></a> */}
                    {/* <Button className="intent-skip" onClick={() => CloseChanges()}> Cancel </Button> */}
                </div>
            </Row>
        </>
    )
}
